	export enum ReportTypeFilterEnum {
		TeleHealth = 1
	}
